export default __webpack_public_path__ + "static/media/note_hero.86b2091c.svg";